import React from "react";
import PropTypes from "prop-types";

import styled from "styled-components";
import { Col } from "react-bootstrap";
import { IoFunnel } from "react-icons/io5";

import BreadCrumbs from "../common/BreadCrumbs";

import { SupportResourcesInfoHeader } from "./components";

const SupportResourcesPageHeader = ({ onClick, isNightMode }) => (
  <HeaderStyles className="header-wrapper">
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <BreadCrumbs breadcrumbs={[{ label: "Support Resources" }]} />
      <div style={{ alignSelf: "end", marginLeft: "-20px" }}>
        <SupportResourcesInfoHeader isNightMode={isNightMode} />
      </div>
    </div>
    <Col md={6} xs={5} className="flex -end" style={{ display: "flex" }}>
      <button className="btn btn-purple" onClick={onClick}>
        <IoFunnel />
      </button>
    </Col>
  </HeaderStyles>
);

const HeaderStyles = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 0;
  h1 {
    font-size: 25px;
    font-weight: 800;
    letter-spacing: -1px;
  }
  .btn {
    margin-top: 10px;
    height: 40px;
  }
`;

SupportResourcesPageHeader.propTypes = {
  onClick: PropTypes.func,
  isNightMode: PropTypes.bool
};

export default SupportResourcesPageHeader;
